module.exports = __webpack_public_path__ + "img/alert_yellow.4599b267.svg";